define([], ()=> {
    const REQUIRED_DISPLAYKEY = 'displaykey.Edge.Web.Api.Model.NotNull';

    return (currentViewModelNode, translator)=> {
        return {
            'valid': {
                'get': ()=> {
                    return !(currentViewModelNode.aspects.required &&
                    (currentViewModelNode.answer === undefined || currentViewModelNode.answer === null));
                }
            },
            'validationMessages': {
                'get': ()=> {
                    if (!currentViewModelNode.aspects.valid) {
                        return [translator(REQUIRED_DISPLAYKEY)];
                    }
                    return [];
                }
            },
            'validationMessage': {
                'get': ()=> {
                    if (!currentViewModelNode.aspects.valid) {
                        return translator(REQUIRED_DISPLAYKEY);
                    }
                }
            }
        };
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/questionsets/aspects/Validity.js
 **/